import * as React from "react";
import { Button, Space, Tooltip } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { CardContent } from "../../../components/antd/card/CardContent";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";
import { CpLabelTooltip } from "../../gvc/testNewForm/CpLabelTooltip";
import { CpTooltip } from "../../gvc/testNewForm/CpTooltip";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {}
export const SecretDataAzureConnector: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const isEdit = useCpFormValue(`meta.isEdit`);
  const isCodeVisible = useCpFormValue(`azureConnector.code.isVisible`);

  return (
    <>
      <CardContent>
        <div style={{ width: 600 }}>
          <CpFormItem>
            <CpLabelTooltip>
              <CpLabel name={`azureConnector.url`}>URL</CpLabel>
              <CpTooltip tooltipProps={{ title: `Url to the iam-broker Azure connection` }} />
            </CpLabelTooltip>
            <CpInput name={`azureConnector.url`} />
            <CpErrorWarning name={`azureConnector.url`} />
          </CpFormItem>
          <CpFormItem>
            <CpLabelTooltip>
              <CpLabel name={`azureConnector.code.value`}>Code</CpLabel>
              <CpTooltip tooltipProps={{ title: `Access code to call the function` }} />
            </CpLabelTooltip>
            {isEdit ? (
              <Space.Compact>
                <CpInput name={`azureConnector.code.value`} type={isCodeVisible ? "text" : "password"} />
                <Tooltip title={isCodeVisible ? "Hide" : "Show"}>
                  <Button
                    onClick={() => formSetValue(id, `azureConnector.code.isVisible`, !isCodeVisible)}
                    icon={isCodeVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                  />
                </Tooltip>
              </Space.Compact>
            ) : (
              <CpInput name={`azureConnector.code.value`} />
            )}
            <CpErrorWarning name={`azureConnector.code.value`} />
          </CpFormItem>
        </div>
      </CardContent>
    </>
  );
};
